@for (stat of mappedStatistics; track stat) {
  <div class="stat" [class.fade-out]="isLoading">
    <div class="stat-value">
      @if (stat.type === 'PERCENTAGE') {
        {{ stat.value }}%
      }
      @if (stat.type === 'CURRENCY') {
        {{ stat.value | currency }}
      }
      @if (stat.type === 'NUMBER') {
        {{ stat.value | number }}
      }
      @if (stat.type === 'TEXT') {
        {{ stat.value }}
      }
    </div>
    <div class="row">
      <div class="stat-label col-12">
        {{ 'Statistic.' + stat.id | trans }}
      </div>
    </div>
  </div>
}
